export default [
  [`Размеры`, `XS`, `S`, `M`, `L`, `XL`, `2XL`, `3XL`, `4XL`, `5XL`, `6XL`],
  [
    `Российский размер`,
    `44`,
    `46`,
    `48`,
    `50`,
    `52`,
    `54`,
    `56`,
    `58`,
    `60`,
    `62`
  ],
  [
    `Плечи`,
    `43,4`,
    `44,6`,
    `45,8`,
    `47`,
    `48,5`,
    `49,6`,
    `50,9`,
    `52,2`,
    `53,5`,
    `54,8`
  ],
  [`Грудь`, `47`, `49`, `51`, `53`, `55`, `57`, `59`, `61`, `63`, `65`],
  [`Длина`, `70`, `71`, `72`, `75`, `75`, `77`, `77`, `79`, `79`, `81`]
];
